const ENV_STYLES: Record<string, { label: string; className: string }> = {
  dev: { label: 'DEVELOPMENT ENVIRONMENT', className: 'bg-green-600' },
  test: { label: 'TEST ENVIRONMENT', className: 'bg-orange-500' },
  staging: { label: 'STAGING ENVIRONMENT', className: 'bg-red-500' },
  dr: { label: 'DISASTER RECOVERY ENVIRONMENT', className: 'bg-blue-600' },
};

/** Coloured strip identifying the non-prod environment. Renders nothing in prod. */
export default function EnvBanner() {
  const env = import.meta.env.VITE_APP_ENV;
  if (env === 'prod') return null;

  const style = env ? ENV_STYLES[env] : undefined;
  const { label, className } = style ?? {
    label: 'UNKNOWN ENVIRONMENT',
    className: 'bg-red-600',
  };

  return (
    <div className={`w-full text-center text-white text-xs font-semibold py-1 ${className}`}>
      {label}
    </div>
  );
}
